// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module__link___FikkA","active":"styles-module__active___FdzGb"};